module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_anchor_arrow_gold-8cd14a89dff0020e6e4b97ba2bcb130c.svg";